import React from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { SubHeader } from '../../../components'
import CheckboxListMerchantAcctCurrency from '../../../components/CheckboxListMerchantAcctCurrency'

class OnlineDDRegistration extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      subAccountId: null,
      accountNo: "",
      paymentCallbackUrl: "",
      registerCallbackUrl: "",
      merchantAccountCurrencyList: []
    }
  }

  onChange = (name, value) => {
    this.setState({ [name]: value })
  }

  render() {
    let { props } = this
    return (
      <React.Fragment >
        <SubHeader text="Online Direct Debit Registration" />
        <Row style={{ padding: "1rem 0" }}>
          <Col sm={6} className="border-right">
            <OnlDDRegOptForm  merchantAccountCurrencyList={props.merchantAccountCurrencyList}  onlDDRegOpt={props.onlDDRegOpt} action={props.action} disabled={props.disabled} />
          </Col>
          {props.onlDDRegOpt.currencyInfo.length < 1 || (props.onlDDRegOpt.currencyInfo.length == 1 && props.onlDDRegOpt.currencyInfo[0].currencyName == "THB") ? <></>
          :<Col>
            <OnlDDRegPurposeCodeOpt onlDDRegOpt={props.onlDDRegOpt} disabled={props.disabled}/>
          </Col> }
        </Row>
      </React.Fragment>
    )
  }
}
export default OnlineDDRegistration

const OnlDDRegOptForm = ({ action, onChange, list = [], merchantAccountCurrencyList = [], onlDDRegOpt, disabled }) => {

  const authenOpt = [
    //{ title:"Authentication Channel Option",label: "ATM/Debit Card", name: "ATM", disabled: true, width: "130px"},
    //{ title:"Authentication Channel Option",label: "Easy App", name: "Easy", disabled: true, width: "130px"  }
    {label: "ATM/Debit Card", name: "ATM", disabled: true, width: "130px",checked:onlDDRegOpt?.authenOpt.ATM },
    {label: "Easy App", name: "Easy", disabled: true, width: "130px",checked:onlDDRegOpt?.authenOpt.Easy  }
  ];
  const accountCurrOpt =
    merchantAccountCurrencyList.map(value => ({
      title:"Account Currency Option",label: value.currencyName, name: value.currencyName, disabled: true, width: "60px",
      checked:onlDDRegOpt?.currencyInfo?.some((currencyInfo) => currencyInfo.currencyName === value.currencyName)
    }));

  return (
    <React.Fragment>
      <Row className="pt-2">
        <Col className="pr-5">
          {/* <Form.Label className={"text-grey font-weight-bold medium required"}>Authentication Channel Option</Form.Label> */}
          <CheckboxListMerchantAcctCurrency 
          text="Authentication Channel Option"
            list={authenOpt}
            disabled={disabled}
            required
            widthAlertDefualtBroswer="280px"
            message="Please Select Authentication Channel"
          />
          <CheckboxListMerchantAcctCurrency 
          text="Account Currency Option"
            list={accountCurrOpt}
            disabled={disabled}
            required
            style={{ fontSize: "4.125rem" }}
            widthAlertDefualtBroswer="280px"
            message="Please Select Account Currency Option"
          />
        </Col>
      </Row>
    </React.Fragment>
  );

}

const OnlDDRegPurposeCodeOpt = ({ action, onChange, businessPurposeList, onlDDRegOpt, alertOnlDDRegOpt, disabled }) => {

  return (
  <React.Fragment>
      <Col className='mt-3 pt-2 text-grey font-weight-bold medium'>
        <Row style={{marginBottom: "2.5rem"}}>
          <Col>Purpose Code Option</Col>
        </Row>
        <Row className='mb-3 align-items-center'>
          <Col xs={4}>
            <Form.Label className="required">{"Purpose Code"}</Form.Label>
          </Col>
          <Col>
            <Form.Control 
                    id='purposeCode'
                    as="select" 
                    name="PurposeCode" 
                    value={onlDDRegOpt.purposeCode}
                    disabled
                    required>
                      <option value="" hidden >Select</option>
                      <option value={onlDDRegOpt.purposeCode}>{onlDDRegOpt.purposeCode}</option>
            </Form.Control>
          </Col>
        </Row>
        <Row className='mb-3 align-items-center'>
          <Col xs={4}>
            Purpose Description
          </Col>
          <Col>
            <Form.Control 
                      style={{ resize: 'none', fontSize: "0.8rem" }}
                      as={"textarea"}
                      name={"PurposeDesc"} 
                      rows={3}
                      disabled
                      value={onlDDRegOpt.purposeDesc} 
                      placeholder={""}  />
          </Col>
        </Row>
        <Row className='mb-3 align-items-center'>
          <Col xs={4}>
            Purpose Terms and Condition
          </Col>
          <Col>
            <Form.Control 
                      style={{ resize: 'none', fontSize: "0.8rem" }}
                      as={"textarea"}
                      name={"PurposeTerm"} 
                      rows={5}
                      disabled
                      value={onlDDRegOpt.purposeTerms}  
                      placeholder={""}  />
          </Col>
        </Row>
      </Col>
  </React.Fragment>);
}